"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var http_1 = require("@angular/http");
var config_1 = require("../../config");
var constants_1 = require("../../constants");
var toolKeys = require('../../resources/localizable/toolKeys.json');
var services_1 = require("../../services");
var canvasRender_1 = require("../../renders/canvasRender");
var gameView_1 = require("../../gameView");
var Module = window.Module;
var LevelComponent = (function () {
    function LevelComponent(activatedRoute, router, http, renderer, packLevelService, localizationService, progressService, resourcePreloaderService, eventService, storageService, userService) {
        var _this = this;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.http = http;
        this.renderer = renderer;
        this.packLevelService = packLevelService;
        this.localizationService = localizationService;
        this.progressService = progressService;
        this.resourcePreloaderService = resourcePreloaderService;
        this.eventService = eventService;
        this.storageService = storageService;
        this.userService = userService;
        this.sendSolutionUrl = config_1.SEND_SOLUTION_URL;
        this.sendBestSolutionUrl = config_1.SEND_BEST_SOLUTION_URL;
        this.currentLang = this.localizationService.currentLang;
        this.currentLangLinkAppStore = this.localizationService.currentLangLinkAppStore;
        this.urlPartPath = constants_1.RETINA ? '2x/retina_' : '1x/';
        this.RETINA = constants_1.RETINA;
        this.canUndo = false;
        this.canRedo = false;
        this.exploreActive = false;
        this.shouldShowResult = true;
        this.shouldShowVStar = false;
        this.isMoveToolTutorial = false;
        this.needLevelDetailOpen = true;
        this.isLevelDecoded = false;
        this.lMoves = 0;
        this.eMoves = 0;
        this.starsResult = {};
        this.justEarnedStars = {};
        this.tools = [];
        this.toolsLocals = {};
        this.hotKeysLocals = {};
        this.rootLevelUrl = this.localizationService.getRootUrlForLevel();
        this.browser = (function () {
            var ua = navigator.userAgent;
            var tem;
            var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE ' + (tem[1] || '');
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem != null)
                    return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null)
                M.splice(1, 1, tem[1]);
            return M.join(' ');
        })();
        this.interfaceCalculation = function (resized) {
            this.render.wrapper.style.width = window.innerWidth + 'px';
            this.render.wrapper.style.height = window.innerHeight + 'px';
            this.render.canvas.width = window.innerWidth;
            this.render.canvas.height = window.innerHeight;
            if (this.gameView) {
                this.gameView.gameControl.setViewSize(this.render.canvas.width, this.render.canvas.height);
                this.render.renderFigures();
            }
            var counter = document.getElementById('moves-counter-wrapper');
            var counterWidth = counter.clientWidth > 53 ? counter.clientWidth : 53;
            counter.style.left = (window.innerWidth / 2 - counterWidth / 2) + 'px';
        }.bind(this);
        this.localizationService.toolsLocals.then(function (result) {
            _this.toolsLocals = result;
        });
        this.localizationService.hotKeysLocals.then(function (result) {
            _this.hotKeysLocals = result;
        });
    }
    LevelComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscribeOnEvents();
        this.subscriptionRouter = this.activatedRoute.params.subscribe(function (params) {
            _this.starsResult = {};
            _this.justEarnedStars = {};
            _this.levelId = params.levelId;
            _this.levelId = _this.packLevelService.levelIdsByNumbers[_this.levelId] || _this.levelId;
            _this.level = _this.packLevelService.levels[_this.levelId];
            _this.isLevelDecoded = false;
            _this.imageUrl = require("../../assets/images/png/levels/" + (_this.urlPartPath + _this.levelId) + "Detailed.png");
            _this.canUndo = false;
            _this.canRedo = false;
            _this.exploreActive = false;
            _this.shouldShowResult = true;
            _this.shouldShowVStar = false;
            _this.shouldShowVHelp = false;
            _this.isMoveToolTutorial = false;
            _this.needLevelDetailOpen = true;
            _this.tutorial = _this.level.tutorial;
            _this.packNumber = _this.level.packNumber;
            _this.levelNumber = _this.level.levelNumber;
            _this.goalLineMoves = _this.level.goalLineMoves;
            _this.goalElementaryMoves = _this.level.goalElementaryMoves;
            _this.pack = _this.packLevelService.packWithLevelId(_this.levelId);
            _this.isMoveToolTutorial = _this.level.levelId == _this.packLevelService.GM_MOVE_TOOL_TUTORIAL_LEVEL_ID;
            _this.isLevelLocked = _this.progressService.isLevelLocked(_this.levelId);
            _this.needLevelDetailOpen = _this.progressService.playedLevels.indexOf(_this.levelId) == -1;
            _this.nextLevelId = _this.packLevelService.nextLevelId(_this.levelId);
            _this.nextLevelIsLocked = _this.progressService.isLevelLocked(_this.nextLevelId);
            _this.nextPackForLevel = _this.packLevelService.packWithLevelId(_this.nextLevelId);
            _this.prevLevelId = _this.packLevelService.previousLevelId(_this.levelId);
            _this.prevLevelIsLocked = _this.progressService.isLevelLocked(_this.prevLevelId);
            _this.prevPackForLevel = _this.packLevelService.packWithLevelId(_this.prevLevelId);
            _this.levelResult = _this.progressService.levelsResults[_this.levelId];
            _this.setFoundVariants();
            _this.setStarsResult();
            if (!_this.render) {
                _this.render = new canvasRender_1.CanvasRender('scene_wrapper');
            }
            _this.setTitleInHead();
            //Star results
            _this.init();
        });
    };
    LevelComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
        if (this.render) {
            this.render.remove();
        }
        window.removeEventListener('resize', this.interfaceCalculation);
    };
    LevelComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptionNextLevelEvent = this.eventService.subscribe('nextLevel', function () { return _this.goToNextLevel(); });
        this.subscriptionLevelScreenEvent = this.eventService.subscribe('levelScreen', function () { return _this.goToLevelsScreen(); });
        this.subscriptionRestartEvent = this.eventService.subscribe('restart', function () { return _this.restart(); });
        this.subscriptionHintCheckerEvent = this.eventService.subscribe('hintChecker', function () { return _this.hintChecker(); });
        this.subscriptionProgressSyncEvent = this.eventService.subscribe('progressSynced', function () {
            _this.setFoundVariants();
            _this.setStarsResult();
        });
    };
    LevelComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptionRouter.unsubscribe();
        this.subscriptionNextLevelEvent.unsubscribe();
        this.subscriptionLevelScreenEvent.unsubscribe();
        this.subscriptionRestartEvent.unsubscribe();
        this.subscriptionHintCheckerEvent.unsubscribe();
    };
    LevelComponent.prototype.undoRedo = function ($event) {
        if (this.isLocked || this.levelSuccessOpen) {
            return;
        }
        var char = String.fromCharCode($event.charCode).toLowerCase();
        if (char === 'z' || $event.charCode === 26 || $event.code === 'KeyZ') {
            if (!$event.shiftKey && $event.ctrlKey) {
                if (this.isCanUndo()) {
                    this.undo();
                    return;
                }
            }
            else if ($event.shiftKey && $event.ctrlKey) {
                if (this.isCanRedo()) {
                    this.redo();
                    return;
                }
            }
        }
        for (var i = toolKeys.length; i--;) {
            var el = toolKeys[i];
            if (el.chars && el.chars.indexOf(char) > -1) {
                this.createEvent(el.tool);
                break;
            }
        }
    };
    LevelComponent.prototype.keyUpHandler = function ($event) {
        if ($event.keyCode === 33) {
            this.gameView.scaleField(1, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateBegan);
            this.gameView.scaleField(1.1, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateChanged);
            this.gameView.scaleField(1.1, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateEnded);
            return;
        }
        if ($event.keyCode === 34) {
            this.gameView.scaleField(1, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateBegan);
            this.gameView.scaleField(0.9, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateChanged);
            this.gameView.scaleField(0.9, {
                x: this.render.halfWidth,
                y: this.render.halfHeight
            }, Module.MoveState.MoveStateEnded);
            return;
        }
    };
    LevelComponent.prototype.createEvent = function (tool) {
        if (this.tools.indexOf(tool) !== -1) {
            this.setToolType(tool);
        }
    };
    LevelComponent.prototype.showModalDescription = function () {
        this.eventService.fire('showModalDescription');
    };
    LevelComponent.prototype.showModalHelp = function () {
        this.eventService.fire('showModalHelp', true);
    };
    LevelComponent.prototype.showModalSuccess = function () {
        this.lockScene();
        if (!this.levelResult.justEarnedStars.length) {
            this.renderOldStars();
        }
        else if (this.levelResult.justEarnedStars.length < Object.keys(this.starsResult).length) {
            this.animateRestStars();
        }
        this.startAnimateStars();
    };
    LevelComponent.prototype.disablePointerEvents = function () {
        this.renderer.addClass(document.body, 'disable');
    };
    LevelComponent.prototype.enablePointerEvents = function () {
        this.renderer.removeClass(document.body, 'disable');
    };
    LevelComponent.prototype.showModalHelpAddon = function () {
        this.eventService.fire('showModalHelpAddon');
    };
    LevelComponent.prototype.showModalHelpAddonCircle = function () {
        this.eventService.fire('showModalHelpAddonCircle');
    };
    LevelComponent.prototype.showModalHintExplore = function () {
        this.eventService.fire('showModalHintExplore');
    };
    LevelComponent.prototype.setFoundVariants = function () {
        this.foundVariantsCount = this.levelResult && this.levelResult.v_count;
    };
    LevelComponent.prototype.lockScene = function () {
        this.render.lockScene(true);
        this.isLocked = true;
        this.disablePointerEvents();
    };
    LevelComponent.prototype.renderOldStars = function () {
        for (var star in this.starsResult) {
            this.justEarnedStars[star] = star;
        }
    };
    LevelComponent.prototype.animateRestStars = function () {
        var oldResultObject = {};
        var levelResultObject = {};
        for (var _i = 0, _a = this.levelResult.justEarnedStars; _i < _a.length; _i++) {
            var star = _a[_i];
            levelResultObject[star] = star;
        }
        for (var star in this.starsResult) {
            if (!levelResultObject[star]) {
                this.justEarnedStars[star] = star;
            }
        }
    };
    LevelComponent.prototype.startAnimateStars = function () {
        var _this = this;
        setTimeout(function () {
            _this.render.lockScene(false);
            _this.levelSuccessOpen = true;
            _this.isLocked = false;
            _this.enablePointerEvents();
            _this.eventService.fire('showModalSuccess');
            var iteratorStars = _this.levelResult.justEarnedStars[Symbol.iterator]();
            var i = 0;
            var interval = setInterval(function () {
                if (i === 2) {
                    clearInterval(interval);
                }
                var propStar = iteratorStars.next().value;
                _this.justEarnedStars[propStar] = propStar;
                i++;
            }, 300);
        }, 1500);
    };
    LevelComponent.prototype.clear = function () {
        localStorage.clear();
        location.reload();
    };
    LevelComponent.prototype.hintChecker = function () {
        var shouldShowHint = false;
        if (this.levelId === 'CircleCenter') {
            var circleHintAlreadyShown = JSON.parse(this.storageService.get('CircleHintAlreadyShown'));
            if (!circleHintAlreadyShown) {
                shouldShowHint = true;
            }
        }
        this.levelSuccessOpen = false;
        if (this.shouldShowVHelp) {
            this.showModalHelpAddon();
            this.shouldShowVHelp = false;
        }
        if (shouldShowHint) {
            this.showModalHelpAddonCircle();
        }
    };
    LevelComponent.prototype.init = function () {
        var _this = this;
        this.http.get(require("../../resources/levels/Gmt/" + this.levelId + ".gmt"))
            .subscribe(function (data) {
            var gameControl = _this.packLevelService.gameControl;
            gameControl.setStyleFile(_this.resourcePreloaderService.styles, Module.GMGameViewRenderStyle.GMStandartRenderStyle);
            if (!_this.gameView) {
                _this.gameView = new gameView_1.GameView(gameControl, _this.render, _this);
                window.addEventListener('resize', _this.interfaceCalculation);
            }
            _this.loadToolPanel(true);
            _this.interfaceCalculation(true);
            _this.gameView.decodeTaskWithFormatWithUndoList(data.text(), Module.GMTaskFormat.GMGeomTaskFormat, false);
            _this.isLevelDecoded = true;
            _this.progressService.setLastPlayedLevelId(_this.levelId);
            _this.setToolType(_this.defaultToolType());
            _this.render.renderFigures();
        });
    };
    LevelComponent.prototype.setStarsResult = function () {
        if (this.levelResult && this.levelResult.stars.length != 0) {
            var resultStars = this.levelResult.stars;
            for (var i = 0; i < resultStars.length; i++) {
                this.starsResult[resultStars[i]] = resultStars[i];
            }
        }
    };
    LevelComponent.prototype.setTitleInHead = function () {
        var _this = this;
        this.localizationService.levelLocals
            .then(function (locals) {
            _this.localizationService.setTitleInHead(locals[_this.levelId].title);
        });
    };
    LevelComponent.prototype.loadToolPanel = function (isForcePlayMode) {
        if (this.gameView.gameMode() == Module.GMGameMode.GMPlayMode || isForcePlayMode) {
            this.tools = this.progressService.toolTypesAvailableForLevel(this.levelId);
        }
        else {
            this.tools = this.progressService.toolTypesAvailableForExploreForLevel(this.levelId);
        }
    };
    LevelComponent.prototype.setToolType = function (toolId) {
        this.gameView.setToolType(toolId);
    };
    LevelComponent.prototype.toolType = function () {
        return this.gameView.toolType();
    };
    LevelComponent.prototype.getToolTitle = function (toolId) {
        if (this.toolsLocals[toolId] && this.hotKeysLocals[toolId]) {
            return this.toolsLocals[toolId].title + ' (' + this.hotKeysLocals[toolId] + ')';
        }
        else {
            return '';
        }
    };
    LevelComponent.prototype.defaultToolType = function () {
        var availableTypes = this.progressService.toolTypesAvailableForLevel(this.levelId);
        if (availableTypes.length == 0) {
            return null;
        }
        else if (availableTypes.length == 1) {
            return availableTypes[0];
        }
        else if (availableTypes.indexOf('CircleTool') != -1) {
            return 'CircleTool';
        }
        else if (this.level.allowedToolTypes != null && this.level.allowedToolTypes.length > 0) {
            return this.level.allowedToolTypes[0];
        }
        return availableTypes[0];
    };
    LevelComponent.prototype.notifyTouchScreen = function (status) {
    };
    LevelComponent.prototype.notifyChangeUndoStatus = function () {
        this.canUndo = this.isCanUndo();
    };
    LevelComponent.prototype.notifyChangeRedoStatus = function () {
        this.canRedo = this.isCanRedo();
    };
    LevelComponent.prototype.isCanUndo = function () {
        return this.gameView.isCanUndo();
    };
    LevelComponent.prototype.isCanRedo = function () {
        return this.gameView.isCanRedo();
    };
    LevelComponent.prototype.notifyChangeTaskStatus = function () {
        if (this.isMoveToolTutorial) {
            return;
        }
        if (this.gameView.solved() != Module.GMSolvedStatus.GMNoSolution) {
            this.handleResult();
        }
    };
    LevelComponent.prototype.notifyChangeGameMode = function () {
    };
    LevelComponent.prototype.notifyChangeCursor = function (status) {
        if (status) {
            this.render.wrapper.style.cursor != 'move' ? this.render.wrapper.style.cursor = 'pointer' : '';
        }
        else {
            this.render.wrapper.style.cursor != 'move' ? this.render.wrapper.style.cursor = 'default' : '';
        }
    };
    LevelComponent.prototype.notifyMovePoint = function () {
        if (!this.isMoveToolTutorial) {
            return;
        }
        if (this.shouldShowResult) {
            this.handleResult();
        }
    };
    LevelComponent.prototype.notifyChangeMoveCount = function () {
        this.updateMoveLabel();
    };
    LevelComponent.prototype.handleResult = function () {
        if (!this.isLevelDecoded) {
            return;
        }
        if (this.gameView.gameMode == Module.GMGameMode.GM_EXPLORE_MODE) {
            return;
        }
        var needToSend = false;
        var levelResult = {};
        levelResult.levelId = this.level.levelId;
        levelResult.date = (new Date()).toISOString();
        levelResult.e_moves = this.gameView.elementaryMovesCount();
        levelResult.l_moves = this.gameView.lineMovesCount();
        var solved = this.gameView.solved();
        switch (solved.value) {
            case Module.GMSolvedStatus.GMNoSolution.value:
                levelResult.v_count = 0;
                break;
            case Module.GMSolvedStatus.GMOneSolution.value:
                levelResult.v_count = 1;
                break;
            case Module.GMSolvedStatus.GMAllSolution.value:
                levelResult.v_count = this.level.variantsCount;
                break;
            default:
                break;
        }
        levelResult.stars = this.level.starsForSolutionWithElementaryMovesLineMovesVariantsFound(levelResult.e_moves, levelResult.l_moves, levelResult.v_count);
        levelResult.encodedHints = '';
        var bestResult = this.progressService.levelsResults[this.level.levelId];
        if (bestResult && bestResult.v_count === undefined) {
            bestResult.v_count = 1;
        }
        if (bestResult == undefined) {
            if (!this.isLevelLocked) {
                needToSend = true;
            }
        }
        else if (bestResult.e_moves > levelResult.e_moves || bestResult.l_moves > levelResult.l_moves || bestResult.v_count < levelResult.v_count) {
            needToSend = true;
            if (!this.shouldShowResult) {
                this.shouldShowResult = true;
            }
            if (bestResult.v_count < levelResult.v_count) {
                this.shouldShowVStar = true;
            }
        }
        if (this.isLevelLocked) {
            this.shouldShowResult = false;
            if (this.levelResult == null) {
                needToSend = true;
                this.shouldShowResult = true;
                this.levelResult = levelResult;
                this.levelResult.justEarnedStars = levelResult.stars;
            }
            else {
                bestResult = this.levelResult;
                this.fakeRegisterResultForLevel(levelResult);
                if (bestResult.e_moves > levelResult.e_moves || bestResult.l_moves > levelResult.l_moves || bestResult.v_count < levelResult.v_count) {
                    this.shouldShowResult = true;
                    needToSend = true;
                }
            }
            if (this.levelResult.v_count < levelResult.v_count) {
                this.levelResult.v_count = levelResult.v_count;
                this.shouldShowVStar = true;
            }
        }
        else {
            this.progressService.registerResultForLevel(levelResult, this.level.levelId);
            this.levelResult = this.progressService.levelsResults[this.level.levelId];
            this.levelResult.justEarnedStars = levelResult.justEarnedStars;
        }
        if (needToSend) {
            if (this.storageService.get('userToken')) {
                this.sendBestSolution(levelResult);
            }
            this.sendSolution(levelResult);
        }
        if (this.shouldShowResult) {
            this.setFoundVariants();
            this.setStarsResult();
            this.showModalSuccess();
            this.shouldShowResult = false;
            this.nextLevelIsLocked = this.progressService.isLevelLocked(this.nextLevelId);
            if (this.levelId == 'TEquilateral' && this.levelResult && this.levelResult.stars.indexOf('GM_STAR_TYPE_V') == -1) {
                this.shouldShowVHelp = true;
            }
        }
    };
    LevelComponent.prototype.sendSolution = function (levelResult) {
        var version = this.progressService.sharedPreferences[this.progressService.GM_APP_VERSION_STR];
        var requestParameters = {
            app_version: version.charAt(0) == 'v' ? version.slice(1) : version,
            level_id: levelResult.levelId,
            date: levelResult.date,
            lang: navigator.browserLanguage || navigator.language || navigator.userLanguage || this.currentLang,
            gmt: this.gameView.encodeTaskWithUndoList(true),
            e_moves: levelResult.e_moves,
            l_moves: levelResult.l_moves,
            v_count: levelResult.v_count,
            stars: this.levelResult.stars.length,
            app: 'BrowserGeom',
            browser: this.browser
        };
        this.httpPost(this.sendSolutionUrl, requestParameters);
        this.userService.sync();
    };
    LevelComponent.prototype.sendBestSolution = function (levelResult) {
        var requestParameters = {
            level_id: levelResult.levelId,
            date: levelResult.date,
            encoded_solution: this.gameView.encodeTaskWithUndoList(true),
            e_moves: levelResult.e_moves,
            l_moves: levelResult.l_moves,
            v_count: levelResult.v_count
        };
        this.httpPost(this.sendBestSolutionUrl + "?token=" + this.storageService.get('userToken'), requestParameters);
    };
    LevelComponent.prototype.httpPost = function (url, params) {
        this.http.post(url, params)
            .toPromise()
            .catch(function (error) {
            console.error('Server error');
        });
    };
    LevelComponent.prototype.fakeRegisterResultForLevel = function (levelResult) {
        var stars = levelResult.stars.slice();
        for (var _i = 0, _a = this.levelResult.stars; _i < _a.length; _i++) {
            var exStar = _a[_i];
            if (stars.indexOf(exStar) == -1) {
                stars.push(exStar);
            }
        }
        var newStars = levelResult.stars.slice();
        for (var _b = 0, _c = this.levelResult.stars; _b < _c.length; _b++) {
            var curStar = _c[_b];
            if (newStars.indexOf(curStar) > -1) {
                newStars.splice(newStars.indexOf(curStar), 1);
            }
        }
        this.levelResult.stars = stars;
        this.levelResult.justEarnedStars = newStars;
    };
    LevelComponent.prototype.updateMoveLabel = function () {
        this.lMoves = this.gameView.lineMovesCount();
        this.eMoves = this.gameView.elementaryMovesCount();
    };
    LevelComponent.prototype.undo = function () {
        if (this.isLocked) {
            return;
        }
        this.gameView.undo();
    };
    LevelComponent.prototype.redo = function () {
        if (this.isLocked) {
            return;
        }
        this.gameView.redo();
    };
    LevelComponent.prototype.restart = function () {
        if (this.isLocked || this.shouldShowVHelp) {
            return;
        }
        this.init();
        this.gameView.restart();
        this.updateViewsDependsOnMode();
    };
    LevelComponent.prototype.goToNextLevel = function () {
        if (this.isLocked || this.shouldShowVHelp) {
            return;
        }
        this.router.navigate([this.rootLevelUrl, this.nextPackForLevel.packId, 'level', this.nextLevelId]);
    };
    LevelComponent.prototype.goToPrevLevel = function () {
        if (this.isLocked || this.shouldShowVHelp) {
            return;
        }
        this.router.navigate([this.rootLevelUrl, this.prevPackForLevel.packId, 'level', this.prevLevelId]);
    };
    LevelComponent.prototype.goToLevelsScreen = function () {
        if (this.isLocked || this.shouldShowVHelp) {
            return;
        }
        this.router.navigate([this.rootLevelUrl, this.pack.packId]);
    };
    LevelComponent.prototype.updateViewsDependsOnMode = function () {
        this.loadToolPanel(false);
        this.setToolType(this.defaultToolType());
        this.exploreActive = this.gameView.gameMode() == Module.GMGameMode.GMExploreMode;
    };
    LevelComponent.prototype.toggleExploreMode = function () {
        if (this.isLocked) {
            return;
        }
        if (this.gameView.gameMode() == Module.GMGameMode.GMPlayMode) {
            this.turnOnExploreMode();
        }
        else {
            this.turnOffExploreMode();
        }
        this.updateViewsDependsOnMode();
    };
    LevelComponent.prototype.turnOnExploreMode = function () {
        this.gameView.setGameMode(Module.GMGameMode.GMExploreMode);
        var exploreModeAlreadyShown = JSON.parse(this.storageService.get('ExploreModeAlreadyShown'));
        if (!exploreModeAlreadyShown) {
            this.eventService.fire('showModalHintExplore');
        }
    };
    LevelComponent.prototype.turnOffExploreMode = function () {
        this.gameView.setGameMode(Module.GMGameMode.GMPlayMode);
    };
    return LevelComponent;
}());
__decorate([
    core_1.HostListener('document:keypress', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], LevelComponent.prototype, "undoRedo", null);
__decorate([
    core_1.HostListener('document:keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], LevelComponent.prototype, "keyUpHandler", null);
LevelComponent = __decorate([
    core_1.Component({
        selector: 'level-component',
        template: require('./level.component.pug'),
        styles: [require('./level.component.scss')]
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        router_1.Router,
        http_1.Http,
        core_1.Renderer2,
        services_1.PackLevelService,
        services_1.LocalizationService,
        services_1.ProgressService,
        services_1.ResourcePreloaderService,
        services_1.EventService,
        services_1.StorageService,
        services_1.UserService])
], LevelComponent);
exports.LevelComponent = LevelComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/level/level.component.ts
// module id = 242
// module chunks = 0